import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, IconButton, Link, Skeleton, Stack, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { memo, useRef, useState } from 'react';
import useDashboardQueryFetch from '../../../../../hooks/useDashboardQueryFetch';
import theme from '../../../../../theme';
import { Dashboard } from '../../../../../types/files';
import DescriptionModal from '../../../../modals/tables/dashboards/rows/DescriptionModal';
import useStyles from "../styles";

export const useLocalStyles = makeStyles((theme) => ({
    text: {
        display: '-webkit-box',
        fontFamily: 'Lato',
        fontSize: '0.9rem',
        fontWeight: 500,
        textDecoration: 'none',
        color: theme.colors.neutral['700'],
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'normal',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
    },
}));

const DescriptionCell: React.FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
    const classes = useStyles();
    const localClasses = useLocalStyles();
    const { query: description, queryLoaded: descriptionLoaded } = useDashboardQueryFetch<string>(dashboard.id, 'Description');

    const [descModalOpen, setDescModalOpen] = useState<boolean>(false);
    const descriptionRef = useRef<HTMLElement>(null);

    return (<>
        <Stack width="100%" ref={descriptionRef}>
            {descriptionLoaded ? (<>
                {(!description || description === 'N/A') ? (
                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start">
                        <Link fontFamily="Lato" fontSize="0.9rem" fontWeight={500}
                            color={`${theme.colors.neutral['500']} !important`}
                            underline='hover'
                            onClick={() => setDescModalOpen(true)}
                            sx={{ cursor: 'pointer' }}>
                            {'Add description...'}
                        </Link>
                    </Stack>
                ) : (
                    <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                        <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start">
                            <Typography className={localClasses.text}>
                                {description}
                            </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="stretch" justifyContent="flex-end">
                            <IconButton disableRipple
                                onClick={() => setDescModalOpen(true)}
                                sx={{ padding: 'unset !important'}}>
                                <ExpandMoreIcon className={classes.icon} sx={{ fill: theme.colors.neutral['500'] }} />
                            </IconButton>
                        </Stack>
                    </Stack>
                )}
            </>) : (
                <Box sx={{ width: '100%' }}>
                    <Skeleton animation="wave" className={classes.wave} />
                </Box>
            )}
        </Stack>
        {descModalOpen && (
            <DescriptionModal open={descModalOpen}
                dashboard={dashboard}
                newDescription={!description?.length}
                anchorElement={descriptionRef.current}
                onClose={() => setDescModalOpen(false)} />
        )}
    </>);
}

export default memo(DescriptionCell);
